export enum DesignToken {
  PrimaryMainRGB = "--primary-rgb-main",
  PrimaryMainContrastRGB = "--primary-rgb-main-contrast",
  PrimaryDarkRGB = "--primary-rgb-dark",
  PrimaryDarkContrastRGB = "--primary-rgb-dark-contrast",
  AccentRGB = "--accent-rgb",
  MenuBackgroundRGB = "--menu-background-rgb",
  MenuTextRGB = "--menu-text-rgb",
  FontFamily = "--font-family-main",
  HeadingTextRGB = "--heading-text-rgb",
  ButtonRGB = "--button-rgb",
  ButtonTextRGB = "--button-text-rgb",
  AppBackgroundRGB = "--app-background-rgb",
  HyperlinkRGB = "--hyperlink-rgb",
  ChartRGB1 = "--chart-rgb-1",
  ChartRGB2 = "--chart-rgb-2",
  ChartRGB3 = "--chart-rgb-3",
  PieChartRGB1 = "--pie-chart-rgb-1",
  PieChartRGB2 = "--pie-chart-rgb-2",
  PieChartRGB3 = "--pie-chart-rgb-3",
  PieChartRGB4 = "--pie-chart-rgb-4",
  PieChartRGB5 = "--pie-chart-rgb-5",
  PieChartRGB6 = "--pie-chart-rgb-6",
}

export const designTokens: string[] = Object.values(DesignToken);
